import React, { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/login/PrivateRoute';

const Layout = lazy(() => import('../layout/Layout'));
const Login = lazy(() => import('../pages/Login'));

const Dashboard                 = lazy(() => import('../pages/Dashboard'));
const BuscarPorClaveCatastral   = lazy(() => import('../pages/BuscarPorClaveCatastral'));
const BuscarPorNombre           = lazy(() => import('../pages/BuscarPorNombre'));
const ContribuyenteClaves           = lazy(() => import('../pages/ContribuyenteClaves'));


const BuscarPorCalle        = lazy(() => import('../pages/BuscarPorCalle'));
const BuscarPorNumero        = lazy(() => import('../pages/BuscarPorNumero'));


const SolicitudesPensionado     = lazy(() => import('../pages/SolicitudesPensionado'));

const CapturaPensionadoCaja = lazy(() => import('../pages/CapturaPensionadoCaja'));
const CapturaPensionadoTramite = lazy(() => import('../pages/CapturaPensionadoTramite'));

const VerDocumentosContribuyente = lazy(() => import('../pages/VerDocumentosContribuyente'));

const CapturaCompletaDatosPadron = lazy(() => import('../pages/CapturaCompletaDatosPadron'));



const BuscarPorClaveAlertaCatastral   = lazy(() => import('../pages/BuscarPorClaveAlertaCatastral'));
const BuscarPorNombreAlertaCatastral           = lazy(() => import('../pages/BuscarPorNombreAlertaCatastral'));
const ContribuyenteClavesAlertaCatastral           = lazy(() => import('../pages/ContribuyenteClavesAlertaCatastral'));
const AlertaCatastralCaptura           = lazy(() => import('../pages/AlertaCatastralCaptura'));
const AlertasCatastralesConfirmacion           = lazy(() => import('../pages/AlertasCatastralesConfirmacion'));




const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />

            <Route
                path="/"
                element={
                    <PrivateRoute>
                        <Layout />
                    </PrivateRoute>
                }
            >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="buscar-catastro-clave"     element={<BuscarPorClaveCatastral />} />
                <Route path="buscar-catastro-nombre"    element={<BuscarPorNombre />} />
                <Route path="contribuyente-claves"      element={<ContribuyenteClaves />} />
                <Route path="buscar-domicilio-calle" element={<BuscarPorCalle />} />
                <Route path="buscar-domicilio-numero" element={<BuscarPorNumero />} />
                <Route path="solicitudes-pensionado"    element={<SolicitudesPensionado />} />
                
                <Route path="captura-pensionado-caja"       element={<CapturaPensionadoCaja />} /> 
                <Route path="captura-pensionado-tramite"    element={<CapturaPensionadoTramite />} /> 

                <Route path="ver-documentos-contribuyente"    element={<VerDocumentosContribuyente />} /> 

                <Route path="captura-completa-padron"    element={<CapturaCompletaDatosPadron />} /> 

                <Route path="inscribir-alerta-catastral"    element={<BuscarPorNombreAlertaCatastral />} /> 
                <Route path="inscribir-alerta-clave"    element={<BuscarPorClaveAlertaCatastral />} /> 

                <Route path="contribuyente-claves-alerta"      element={<ContribuyenteClavesAlertaCatastral />} />
                <Route path="alerta-catastral-captura"      element={<AlertaCatastralCaptura />} />
                <Route path="alertas-catastrales-confirmacion"      element={<AlertasCatastralesConfirmacion />} />                

            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

export default AppRoutes;
